<template>
  <div class="add">
    <div class="add-center">
      <!-- 头部 -->
      <header>
        <p>房源/编辑商铺</p>
        <img src="../add/assets/img/return.png" alt="" />
        <!-- <span class="iconfont icon-xiegenjin"></span> -->
      </header>
      <aside>
        <div class="main">
          <div class="main-form">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
              <!--  -->

              <p>核心信息</p>

              <a-row style="display: flex; justify-content: space-between; width: 96%; margin-left: -22px">
                <a-col :span="4">
                  <a-form-model-item ref="lessorsName" label="业主姓名" prop="lessorsName">
                    <a-input style="width: 185px" v-model="form.lessorsName" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="lessorsPhone" label="业主电话" prop="lessorsPhone">
                    <a-input style="width: 185px" v-model="form.lessorsPhone" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-button type="primary" class="addInfor" v-if="addBtnShow" @click="addClick">
                    添加另一位业主信息
                  </a-button>
                </a-col>
                <a-col :span="12"></a-col>
              </a-row>
              <a-row
                style="display: flex; justify-content: space-between; width: 96%; margin-left: -22px"
                v-if="oneShow"
              >
                <a-col :span="4">
                  <a-form-model-item ref="lessorsName" label="业主信息" prop="lessorsName">
                    <a-input
                      style="width: 185px"
                      v-model="form.lessorsName"
                      @blur="
                        () => {
                          $refs.lessorsName.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="lessorsPhone" label="业主电话" prop="lessorsPhone">
                    <a-input
                      style="width: 185px"
                      v-model="form.lessorsPhone"
                      @blur="
                        () => {
                          $refs.lessorsPhone.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-button type="danger" class="addInfor" @click="delClick(1)"> 删除 </a-button>
                </a-col>
                <a-col :span="12"></a-col>
              </a-row>
              <a-row
                style="display: flex; justify-content: space-between; width: 70%; margin-left: -22px"
                v-if="twoShow"
              >
                <a-col :span="4">
                  <a-form-model-item ref="lessorsName" label="业主信息" prop="lessorsName">
                    <a-input
                      style="width: 185px"
                      v-model="form.lessorsName"
                      @blur="
                        () => {
                          $refs.lessorsName.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="lessorsPhone" label="业主电话" prop="lessorsPhone">
                    <a-input
                      style="width: 185px"
                      v-model="form.lessorsPhone"
                      @blur="
                        () => {
                          $refs.lessorsPhone.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-button type="danger" class="addInfor" @click="delClick(2)"> 删除 </a-button>
                </a-col>
                <a-col :span="12"></a-col>
              </a-row>
              <!--  -->
              <a-row style="display: flex; justify-content: space-between; width: 76%; margin-left: -5px">
                <a-col :span="4">
                  <a-form-model-item label="区域" :required="true">
                    <a-select
                      v-model="form.districtId"
                      placeholder="下拉菜单"
                      style="width: 185px"
                      @change="regionChange"
                    >
                      <a-select-option v-for="item in region" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="商圈">
                    <a-select v-model="form.businessDistrictId" placeholder="下拉菜单" style="width: 185px">
                      <a-select-option v-for="item in businessDistrict" :key="item.id" :value="item.id">{{
                        item.id
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item ref="streetId" label="街道" prop="streetId">
                    <a-input style="width: 185px" v-model="form.streetId" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item ref="houseNumber" label="门牌号" prop="houseNumber">
                    <a-input
                      style="width: 65px"
                      v-model="form.houseNumber"
                      @blur="
                        () => {
                          $refs.houseNumber.onFieldBlur()
                        }
                      "
                    />
                    <span>号附</span>
                    <a-input style="width: 57px" v-model="form.houseNumberDeputy" />
                    <span>号</span>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row style="display: flex; justify-content: space-between; width: 96%; margin-left: -75px">
                <a-col :span="4">
                  <a-form-model-item label="所处楼层" :required="true">
                    <a-select v-model="form.houseFloor" placeholder="下拉菜单" style="width: 185px">
                      <a-select-option v-for="item in houseFloor" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="6">
                  <a-form-model-item ref="floorTotal" label="整栋层数" prop="floorTotal">
                    <a-input
                      style="width: 185px"
                      v-model="form.floorTotal"
                      @blur="
                        () => {
                          $refs.floorTotal.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="10"> </a-col>
              </a-row>

              <div class="hr"></div>
              <p>基本信息</p>
              <ul id="basicStore">
                <li>
                  <a-form-model-item ref="shopName" label="店铺名称" prop="shopName">
                    <a-input
                      style="width: 185px"
                      v-model="form.shopName"
                      @blur="
                        () => {
                          $refs.shopName.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="商铺类型" :required="true">
                    <a-select v-model="form.shopTypeId" placeholder="请选择" style="width: 185px" @change="shopChange">
                      <a-select-option v-for="item in shopType" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="商铺性质" :required="true">
                    <a-select v-model="form.shopNatureId" placeholder="二手商铺" style="width: 185px">
                      <a-select-option v-for="item in shopNature" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="经营状态" :required="true">
                    <a-select v-model="form.operatingStatusId" placeholder="空置中" style="width: 185px">
                      <a-select-option v-for="item in operatingStatus" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
              </ul>
              <ul id="current">
                <li>
                  <a-form-model-item label="现经营" :required="true" style="width: 100%">
                    <div style="display: flex">
                      <a-select
                        v-model="form.industryCategoryId"
                        placeholder="行业分类"
                        style="width: 185px; margin-right: 16px"
                      >
                        <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id">{{
                          item.title
                        }}</a-select-option>
                      </a-select>
                      <a-select v-model="form.industrySubclassId" placeholder="经营行业" style="width: 185px">
                        <a-select-option v-for="item in industrySubclass" :key="item.id" :value="item.id">{{
                          item.title
                        }}</a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </li>
                <li style="width: 185px">
                  <a-form-model-item label="是否临街" :required="true">
                    <a-select v-model="form.isFrontage" placeholder="请选择" style="width: 185px; margin-left: -14px">
                      <a-select-option v-for="item in isFrontage1" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="是否可餐饮">
                    <a-select v-model="form.isCatering" placeholder="请选择" style="width: 185px">
                      <a-select-option v-for="item in isCatering1" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item v-show="isCateringStatus">
                    <a-select v-model="food1" placeholder="请选择" style="margin-top: 43px; width: 185px">
                      <a-select-option v-for="item in food" :key="item.id" :value="item.title">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
              </ul>

              <ul class="bacisInfo">
                <li>
                  <a-form-model-item ref="grossFloorArea" label="建筑面积" prop="grossFloorArea">
                    <a-input
                      suffix="m²"
                      style="width: 185px"
                      v-model="form.grossFloorArea"
                      @blur="
                        () => {
                          $refs.grossFloorArea.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="saleableArea" label="实用面积" prop="saleableArea">
                    <a-input v-model="form.saleableArea" style="width: 178px" suffix="m²" />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="houseWide" label="开间" prop="houseWide">
                    <a-input
                      style="width: 185px"
                      v-model="form.houseWide"
                      suffix="m"
                      @blur="
                        () => {
                          $refs.houseWide.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="houseHigh" label="层高" prop="houseHigh">
                    <a-input
                      style="width: 185px"
                      v-model="form.houseHigh"
                      suffix="m"
                      @blur="
                        () => {
                          $refs.houseHigh.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="houseLong" label="进深" prop="houseLong">
                    <a-input
                      style="width: 185px"
                      v-model="form.houseLong"
                      suffix="m"
                      @blur="
                        () => {
                          $refs.houseLong.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
              </ul>

              <a-row class="checkrow">
                <a-col :span="18">
                  <a-form-model-item label="商铺配套">
                    <!-- <a-checkbox-group> -->
                    <ul style="margin-left: -42px">
                      <li style="margin-bottom: 20px; margin-top: 10px">
                        <a-checkbox name="type" :value="form.isGas"> 天然气 </a-checkbox>
                        <label for="">气量</label>
                        <input type="number" v-model="form.gasCapacity" suffix="m³" />
                        <a-checkbox name="type" :checked="form.isOutsideArea"> 外摆区 </a-checkbox>
                        <a-checkbox name="type" :checked="form.isPower"> 动力电 </a-checkbox>
                        <label for="">电功率</label>
                        <input type="number" v-model="form.electricPower" suffix="kw" />
                        <a-checkbox name="type" :checked="form.isEjectSmoke"> 烟道 </a-checkbox>
                      </li>
                      <li>
                        <!-- <a-checkbox name="type" v-model="form.isSewerSystem"> 下水 </a-checkbox>
                                                <a-checkbox name="type" v-model="form.isWaterworks"> 上水 </a-checkbox>
                                                <a-checkbox name="type" v-model="form.isElevator"> 电梯 </a-checkbox>
                                                <a-checkbox name="type" v-model="form.isParkingSpace">
                                                    停车位
                                                </a-checkbox>
                                                <a-checkbox name="type" v-model="form.isTwowayStairs">
                                                    双步梯
                                                </a-checkbox> -->
                        <a-checkbox-group name="xd" :options="form.xingdong" v-model="form.xingdongval" @change="aaa">
                        </a-checkbox-group>
                      </li>
                    </ul>
                    <!-- </a-checkbox-group> -->
                  </a-form-model-item>
                </a-col>
                <a-col :span="6"> </a-col>
              </a-row>

              <a-row class="checkrow">
                <a-col :span="18">
                  <a-form-model-item label="客流人群">
                    <!-- <a-checkbox name="type" v-model="form.isOfficePass"> 办公人群 </a-checkbox>
                                        <a-checkbox name="type" v-model="form.isStudentsPass"> 学生人群 </a-checkbox>
                                        <a-checkbox name="type" v-model="form.isResidentsPass"> 居民人群 </a-checkbox>
                                        <a-checkbox name="type" v-model="form.isTouristPass"> 旅游人群 </a-checkbox>
                                        <a-checkbox name="type" v-model="form.isOtherPass"> 其他 </a-checkbox> -->

                    <a-checkbox-group
                      v-model="valuekeliu"
                      name="checkboxgroup"
                      :options="Optionskeliu"
                      @change="onChangekeliu"
                    >
                    </a-checkbox-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6"> </a-col>
              </a-row>
              <a-row class="checkrow">
                <a-col :span="18">
                  <a-form-model-item label="自定义标签">
                    <!-- <a-checkbox-group> -->
                    <a-checkbox name="type"> 转角轴 </a-checkbox>
                    <a-checkbox name="type"> 十字路口 </a-checkbox>
                    <a-checkbox name="type"> 地铁口 </a-checkbox>
                    <a-checkbox name="type">
                      <span style="color: red"> 小区门口第一间 </span>
                    </a-checkbox>
                    <!-- </a-checkbox-group> -->
                  </a-form-model-item>
                </a-col>
                <a-col :span="6"> </a-col>
              </a-row>

              <div class="hr"></div>
              <p>价格信息</p>
              <ul id="priceInfor">
                <li>
                  <a-form-model-item ref="rentFee" label="租金" prop="rentFee" :required="true">
                    <a-input
                      style="width: 178px"
                      v-model="form.rentFee"
                      suffix="元/月"
                      @blur="
                        () => {
                          $refs.rentFee.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <p style="font-size: 12px">
                    <span>x</span><span style="margin-right: 20px">元/m²/月</span> <span>x</span
                    ><span>元/m²/天</span>
                  </p>
                </li>
                <li>
                  <a-form-model-item ref="rentfreePeriod" label="免租期" prop="rentfreePeriod">
                    <a-input
                      style="width: 178px"
                      suffix="天"
                      v-model="form.rentfreePeriod"
                      @blur="
                        () => {
                          $refs.rentfreePeriod.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="transferFee" label="转让费" prop="transferFee">
                    <a-input
                      style="width: 178px"
                      v-model="form.transferFee"
                      suffix="万元"
                      @blur="
                        () => {
                          $refs.transferFee.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="产权性质" :required="true">
                    <a-select v-model="form.propertyNatureId" placeholder="商业" style="width: 178px">
                      <a-select-option v-for="item in propertyNature" :key="item.id" :value="item.id">{{
                        item.title
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </li>
              </ul>
              <ul id="paymethod">
                <li>
                  <a-form-model-item label="支付方式" :required="true">
                    <div style="display: flex">
                      <span>押</span>
                      <a-input style="width: 178px" v-model="paymentMethod1" suffix="月" />
                      <span>付</span>
                      <a-input style="width: 178px" v-model="paymentMethod2" suffix="月" />
                    </div>
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="递增">
                    <a-input v-model="form.progressiveIncrease" style="width: 492px" />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item label="房佣" :required="true" ref="houseBrokerage" prop="houseBrokerage">
                    <a-input
                      style="width: 178px"
                      v-model="form.houseBrokerage"
                      @blur="
                        () => {
                          $refs.houseBrokerage.onFieldBlur()
                        }
                      "
                    />
                  </a-form-model-item>
                </li>
              </ul>
              <ul id="commfee">
                <li>
                  <a-form-model-item ref="propertyFee" label="商业物业费" prop="propertyFee">
                    <a-input style="width: 178px" v-model="form.propertyFee" suffix="元" />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="electricityFee" label="商业电费" prop="electricityFee">
                    <a-input style="width: 178px" v-model="form.electricityFee" suffix="元/度" />
                  </a-form-model-item>
                </li>
                <li>
                  <a-form-model-item ref="waterFee" label="商业水费" prop="waterFee">
                    <a-input style="width: 178px" v-model="form.waterFee" suffix="元/吨" />
                  </a-form-model-item>
                </li>
              </ul>

              <div class="hr"></div>
              <p>其他信息</p>
              <a-textarea
                placeholder="请输入备注信息"
                :autoSize="true"
                style="width: 100%; height: 200px; border-radius: 10px"
              />

              <a-form-model-item
                :wrapper-col="buttonItemLayout.wrapperCol"
                style="margin-top: 30px; margin-bottom: 20px; text-align: right"
              >
                <a-button type="primary" class="submit" @click="refer">确认</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
      </aside>

      <div style="height: 50px"></div>
    </div>
  </div>
</template>

<script>
// import { houseDetails, editHouseInfoStatus, EdithouseCustomTag } from '@/api/system/houses/house.js'
import houseApi from '@/api/system/houses/house.js'

export default {
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      other: '',
      Optionskeliu: [
        { label: '办公人群', value: 'isOfficePass' },
        { label: '学生人群', value: 'isStudentsPass' },
        { label: '旅游人群', value: 'isTouristPass' },
        { label: '其他', value: 'isOtherPass' }
      ],
      valuekeliu: [],
      form: {
        id: null,
        districtId: undefined,
        districtName: '2',
        lessorsName: '',
        lessorsPhone: '',
        businessDistrictId: 1,
        businessDistrictName: '3',
        lessorInfoBoList: [{ id: null, lessorsName: '111', lessorsPhone: '19938494822' }],
        streetId: 0,
        streetName: '4',
        houseNumber: '5',
        houseNumberDeputy: '6',
        houseFloor: '7',
        houseHigh: 1,
        floorTotal: 11,
        shopName: '8',
        shopTypeId: 1,
        shopNatureId: 1,
        operatingStatusId: 1,
        industryCategoryId: 1,
        industrySubclassId: 1,
        isFrontage: '9',
        isCatering: '13',
        saleableArea: 1,
        houseLong: 1,
        rentFee: 2,
        rentFeeCentiare: 1,
        rentfreePeriod: 1,
        transferFee: 1,
        propertyNatureId: 1,
        paymentMethod: 'Y1F1',
        progressiveIncrease: '14',
        houseBrokerage: 1,
        propertyFee: 100,
        electricityFee: 20,
        waterFee: 30,
        isGas: true,
        gasCapacity: 1,
        isOutsideArea: true,
        isPower: true,
        electricPower: 1,
        isEjectSmoke: false,
        isSewerSystem: false,
        isWaterworks: false,
        isElevator: false,
        isParkingSpace: false,
        isTwowayStairs: false,
        isOfficePass: false,
        isStudentsPass: false,
        isResidentsPass: false,
        isTouristPass: false,
        isOtherPass: true,
        houseWide: 3,
        grossFloorArea: 4,
        xingdong: ['下水', '上水', '停车位', '双步梯', '电梯'],
        xingdongval: []
      },
      food1: '',
      paymentMethod1: 1,
      paymentMethod2: 1,
      EdithouseCustomTagData: {
        housingSetId: 1,
        id: 1,
        tagName: '十字路口'
      },
      food: [
        { id: 0, title: '可轻餐' },
        { id: 1, title: '可重餐' }
      ],
      // 区域
      region: [
      ],
      // 商圈
      businessDistrict: [

      ],
      // 所处楼层
      houseFloor: [
        { id: 0, title: '楼层1' },
        { id: 1, title: '楼层2' }
      ],
      // 商铺类型
      shopType: [
        { id: 0, title: '社区底商' },
        { id: 1, title: '商业街铺' },
        { id: 2, title: '写字楼底商' },
        { id: 3, title: '档口摊位' },
        { id: 4, title: '商业综合体' },
        { id: 5, title: '其他' }
      ],
      // 商铺性质
      shopNature: [
        { id: 0, title: '二手商铺' },
        { id: 1, title: '招商项目' }
      ],
      // 经营状态
      operatingStatus: [
        { id: 0, title: '空置中' },
        { id: 1, title: '经营中' }
      ],
      // 现经营
      industryCategory: [

      ],
      // 经营行业
      industrySubclass: [

      ],
      // 是否临街
      isFrontage1: [
        { id: 0, title: '是' },
        { id: 1, title: '否' }
      ],
      // 是否可餐饮
      isCatering1: [
        { id: 0, title: '是' },
        { id: 1, title: '否' }
      ],
      // 可餐饮状态
      isCateringStatus: 'false',
      // 产权性质
      propertyNature: [
        { id: 0, title: '商业' },
        { id: 1, title: '办公' },
        { id: 2, title: '住宅' },
        { id: 3, title: '农贸市场' },
        { id: 4, title: '其他' }
      ],
      rules: {
        lessorsName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 4, message: '姓名不正确', trigger: 'blur' }
        ],
        lessorsPhone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的电话号码', trigger: 'blur' }
        ],
        streetId: [{ required: true, message: '请输入街道信息', trigger: 'blur' }],
        houseNumber: [{ required: true, message: '请输入门牌号', trigger: 'blur' }],

        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { min: 1, max: 8, message: '最少有一个汉字，最多有8个汉字', trigger: 'blur' }
        ],
        floor: [{ required: true, message: '请输入楼层', trigger: 'blur' }],
        shopName: [{ required: true, message: '请输入店铺信息', trigger: 'blur' }],
        grossFloorArea: [
          { required: true, message: '请输入建筑面积', trigger: 'blur' },
          { message: '建筑面积不得小于零', trigger: 'blur' }
        ],
        houseWide: [
          { required: true, message: '请输入开间', trigger: 'blur' },
          { min: 1, message: '开间数不得小于零', trigger: 'blur' }
        ],
        houseHigh: [
          { required: true, message: '请输入层高', trigger: 'blur' },
          { min: 1, message: '层高不得小于零', trigger: 'blur' }
        ],
        floorTotal: [
          { required: true, message: '请输入整栋层数', trigger: 'blur' },
          { min: 1, message: '层数不得低于0', trigger: 'blur' }
        ],

        grossFloorArea: [
          { required: true, message: '请输入建筑面积', trigger: 'blur' },
          { message: '建筑面积不得小于零', trigger: 'blur' }
        ],

        houseLong: [
          { required: true, message: '请输入进深', trigger: 'blur' },
          { min: 1, message: '进深不得小于零', trigger: 'blur' }
        ],
        rentFee: [
          { required: true, message: '请输入租金', trigger: 'blur' },
          { min: 1, message: '租金不得小于零', trigger: 'blur' }
        ],
        rentfreePeriod: [
          { required: true, message: '请输入免租期', trigger: 'blur' },
          { min: 1, message: '免租期不得小于零', trigger: 'blur' }
        ],
        transferFee: [
          { required: true, message: '请输入转让费', trigger: 'blur' },
          { min: 1, message: '转让费不得小于零', trigger: 'blur' }
        ],
        paymentMethod: [
          { required: true, message: '请输入转让月数', trigger: 'blur' },
          { min: 1, message: '转让月数不得小于零', trigger: 'blur' }
        ],
        houseBrokerage: [
          { required: true, message: '请输入房拥', trigger: 'blur' },
          { min: 1, message: '房拥不得小于零', trigger: 'blur' }
        ],

        type: [
          {
            type: 'array',
            required: true,
            message: 'Please select at least one activity type',
            trigger: 'change'
          }
        ],
        resource: [{ required: true, message: 'Please select activity resource', trigger: 'change' }],
        desc: [{ required: true, message: 'Please input activity form', trigger: 'blur' }]
      },
      oneShow: false,
      twoShow: false,
      addBtnShow: true,
      a: 0,
      shopList: [
        {
          id: '123'
        }
      ]
    }
  },
  created () {
    this.gethouse()
    // 修改自定义标签 测试
    this.EdithouseCustomTagM()
  },
  methods: {
    onChangekeliu () {
      console.log(this.valuekeliu)
    },
    // 添加业主
    addClick () {
      this.a++
      if (this.a == 1) {
        this.oneShow = true
      }
      if (this.a == 2) {
        this.twoShow = true
      }
      if (this.a > 2) {
        this.a = 0
        this.$message.warning('最多只能添加两位业主')
      }
    },
    // 删除业主
    delClick (val) {
      this.a--
      console.log(this.a)
      if (val == 1) {
        this.oneShow = false
      }
      if (val == 2) {
        this.twoShow = false
      }
    },
    // 商铺change事件
    shopChange (val) {
      console.log(val)
      console.log(this.form.shopTypeId)
    },
    onSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },

    buttonItemLayout () {
      const { layout } = this.form
      return layout === 'horizontal'
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {}
    },
    // 区域
    regionChange (val, index) {
      console.log(val, index)
    },
    // 得到全部房源
    gethouse () {
      houseApi.houseDetails(0).then((res) => {
        console.log(res)

        if (res.code == 200) {
          this.form = res.data
          console.log('1', this.form)
        }
      })
    },
    aaa (val) {
      console.log(val)
    },
    // 修改房源信息
    editHouse () {
      houseApi.editHouseInfoStatus({ ...this.form }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('修改成功')
        }
      })
    },
    // 修改自定义标签
    EdithouseCustomTagM () {
      houseApi.EdithouseCustomTag({ ...this.EdithouseCustomTagData }).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          this.$message.success('修改成功')
        }
      })
    },
    // 提交
    refer () {
      this.form.paymentMethod = 'Y' + this.paymentMethod1 + 'F' + this.paymentMethod2
      //  处理是否临街数据（0为true,1为false）
      if (this.form.isFrontage == 0) {
        this.form.isFrontage = true
      } else {
        this.form.isFrontage = false
      }
      this.editHouse()
    }
  }
}
</script>

<style lang="less" scoped>
.add {
  width: 100%;
  // height: 400px;
  // background-color: rgb(107, 3, 3);
  background-color: white;

  .add-center {
    width: 95%;
    margin: 0 auto;
    header {
      height: 80px;
      display: flex;
      align-items: center;

      & > p {
        margin-bottom: 0;
        font-size: 26px;
        font-weight: bold;
        color: black;
      }
      & > img {
        // flex-shrink: 1;
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-top: 3px;
      }
    }
    aside {
      .main {
        width: 94%;
        // height: 100px;
        // background-color: aqua;
        margin: 0 auto;
        background-color: white;

        & > .main-form {
          width: 100%;
          margin: 30px auto 0;
          /deep/ p {
            font-size: 24px;

            color: black;
          }
          /deep/ .ant-col-4 {
            width: 21.666667%;
            text-align: left;
          }
          /deep/ .ant-col-10 {
            width: 29.666667%;
          }
          /deep/ .ant-form-item {
            display: flex;
            flex-direction: column;
          }
          /deep/ .addInfor {
            margin-top: 42px;
          }
          .hr {
            width: 100%;
            height: 1px;
            border: 1px solid #f2f6fc;
            margin-top: 10px;
            margin-bottom: 20px;
          }
          /deep/ .ant-col-12 {
            width: 25%;
          }
          #basicStore {
            list-style: none;
            display: flex;
            justify-content: space-between;
            width: 64%;
            margin-left: -41px;
          }
          #current {
            list-style: none;
            display: flex;
            width: 65.4%;
            justify-content: space-between;
            margin-left: -41px;
            /deep/li {
              width: 200px;
            }
          }
          .bacisInfo {
            width: 80%;
            list-style: none;
            display: flex;
            justify-content: space-between;
            margin-left: -41px;
          }
          .checkrow {
            /deep/ ul {
              list-style: none;
              li {
                label {
                  margin-right: 10px;
                }
                input {
                  width: 60px;
                  border: 1px solid #d9d9d9;
                  outline: none;
                  height: 16px;
                  margin-right: 20px;
                }
              }
            }
          }
          /deep/ #priceInfor {
            width: 65%;
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-left: -41px;

            & > li {
              margin-right: 10px;
            }
          }
          /deep/ #paymethod {
            width: 68%;
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-left: -41px;
          }
          /deep/ #commfee {
            list-style: none;
            display: flex;
            justify-content: space-between;
            width: 37%;
            margin-left: -41px;
          }
          /deep/ .submit {
            width: 80px;
            height: 35px;
            border-radius: 5px;
            font-size: 15px;
            text-align: center;
            line-height: 35px;
            background-color: var(--ThemeColor);
          }
        }
      }
    }
  }
}
</style>
